module.exports = __webpack_public_path__ + "img/shape-5.4d61f683.png";